import { findChallengeById, getTrack, toRuleStructure, type ChallengeLocation } from '@devlearn/content';
import type { ChallengeMeta, TrackStructureFull } from '@devlearn/shared';

export const DEFAULT_TRACK = 'js-fundamentals';

export function trackOf(slug = DEFAULT_TRACK): TrackStructureFull {
  const track = getTrack(slug);
  if (!track) throw new Error(`Unknown track ${slug}`);
  return track;
}

export function ruleStructureOf(slug = DEFAULT_TRACK) {
  return toRuleStructure(trackOf(slug));
}

export function challengePath(loc: Pick<ChallengeLocation, 'track' | 'chapter' | 'challenge'>): string {
  return `/learn/${loc.track.slug}/${loc.chapter.slug}/${loc.challenge.slug}`;
}

export function pathForChallengeId(id: string): string | null {
  const loc = findChallengeById(id);
  return loc ? challengePath(loc) : null;
}

/** The challenge after this one: next in the chapter, else the first of the next chapter, else null. */
export function nextChallenge(trackSlug: string, challengeId: string): ChallengeLocation | null {
  const track = trackOf(trackSlug);
  const flat = track.chapters.flatMap((chapter) =>
    chapter.challenges.map((challenge, i) => ({ track, chapter, challenge, number: i + 1 })),
  );
  const index = flat.findIndex((l) => l.challenge.id === challengeId);
  return index >= 0 ? (flat[index + 1] ?? null) : null;
}

const TYPE_LABEL: Record<ChallengeMeta['type'], string> = {
  predict: 'Predict the output',
  code: 'Code challenge',
  'bug-hunt': 'Bug hunt',
  boss: 'Boss project',
};

export function typeLabel(type: ChallengeMeta['type']): string {
  return TYPE_LABEL[type];
}
